import * as React from 'react'

import { createContext } from '~logic/lib/react'

import { TOrderForm } from './FormProvider'

// the shape that is stored in the persistence
// ! keep in sync with the watched form fields bellow
export type TPersistedForm = Pick<
  TOrderForm,
  | 'givenName' //
  | 'familyName'
  | 'phonePrefix'
  | 'phoneNumber'
  | 'email'
>

type TNullablePersistedForm = Nullable<TPersistedForm>

type TRememberContext = {
  rememberForm: Nullable<boolean>
  setRememberForm: (shouldRemember: boolean) => void
}

type TPersistedNote = Nullable<string>

const [
  PersistedValuesProvider, //
  usePersistedFormValuesCtx,
] = createContext<TNullablePersistedForm>(`FormPersistedValues`)
const [
  RememberProvider, //
  useShouldRememberFormCtx,
] = createContext<TRememberContext>(`ShouldRememberForm`)
const [
  PersistedNoteProvider, //
  usePersistedNoteCtx,
] = createContext<TPersistedNote>(`PersistedNote`)

type TProps = RequiredChildren & {
  persistedNote?: TPersistedNote
  persistedForm?: TNullablePersistedForm
  rememberForm?: TRememberContext['rememberForm']
  setRememberForm: TRememberContext['setRememberForm']
}

/**
 * Provider of the persisted form values
 * and the customers choice state – whether store that data or not.
 */
export const FormPersistenceProvider: React.FC<TProps> = ({
  persistedForm,
  persistedNote,
  rememberForm,
  setRememberForm,
  children,
}) => {
  // persistence not initialized yet
  if (
    rememberForm === undefined || //
    persistedForm === undefined ||
    persistedNote === undefined
  ) {
    return null
  }

  return (
    <PersistedNoteProvider value={persistedNote}>
      <PersistedValuesProvider value={persistedForm}>
        <RememberProvider value={{ rememberForm, setRememberForm }}>{children}</RememberProvider>
      </PersistedValuesProvider>
    </PersistedNoteProvider>
  )
}

export { useShouldRememberFormCtx, usePersistedFormValuesCtx, usePersistedNoteCtx }
